import type { HTMLProps } from "react";

import { FloatingLabelSelect, Skeleton } from "@aviary";
import type { AviaryColorProps } from "@aviary/types/aviaryColors";
import { useStatesQuery } from "@shared/data/queries/StatesQuery/States.query";

interface AviaryInputProps extends AviaryColorProps, HTMLProps<HTMLSelectElement> {}

interface Props extends AviaryInputProps {
  onChange: (e) => void;
  id: string;
  label: string;
  value: string;
  placeholder: string;
  name?: string;
  isRequired?: boolean;
  errors?: string[];
}

const StateSelect = ({
  id,
  onChange,
  label,
  name,
  value = "",
  isRequired,
  placeholder,
  errors,
  ...rest
}: Props) => {
  const { loading: statesLoading, data } = useStatesQuery();
  if (statesLoading) {
    return <Skeleton type="typography" typographySize="h1" isFullWidth />;
  }

  return (
    <FloatingLabelSelect
      id={id}
      name={name}
      label={label}
      handleChange={onChange}
      value={value}
      required={isRequired}
      errors={errors}
      {...rest}
    >
      <option value="" key="" disabled>
        {placeholder}
      </option>
      {data?.viewer.states.map(state => {
        return (
          <option key={state.id} value={state.abbr}>
            {state.name}
          </option>
        );
      })}
    </FloatingLabelSelect>
  );
};

export { StateSelect };
